import type { SxProps, Theme } from '@mui/material/styles';
import { CONTENT_SHAPE } from './contentColors';

/** Editorial page title (sits on the canvas, no card). */
export const PAGE_HEADER_TITLE_SX = {
  fontWeight: 600,
  color: 'text.primary',
  fontSize: { xs: '1.375rem', md: '1.625rem' },
  lineHeight: 1.25,
} as const satisfies SxProps<Theme>;

export const PAGE_HEADER_ACTION_BUTTON_SX = {
  borderRadius: `${CONTENT_SHAPE.sm}px`,
  px: 2,
  py: 1,
} as const satisfies SxProps<Theme>;

/** Tabs row: tabs sit on a full-width hairline (the indicator overlaps it). */
export const PAGE_HEADER_TABS_ROW_SX = {
  borderBottom: 1,
  borderColor: 'divider',
  mt: 1,
} as const satisfies SxProps<Theme>;

export const PAGE_HEADER_TABS_ROW_COMPACT_SX = {
  borderBottom: 1,
  borderColor: 'divider',
  mt: 0.5,
} as const satisfies SxProps<Theme>;

export const PAGE_HEADER_TABS_SX = {
  minHeight: 0,
  mb: '-1px',
} as const satisfies SxProps<Theme>;

export const PAGE_HEADER_TABS_COMPACT_SX = {
  minHeight: 0,
  mb: '-1px',
  '& .MuiTab-root': { minHeight: 40 },
} as const satisfies SxProps<Theme>;
